import { useMemo } from "react";

import toHookValue from "../logic/toHookValue";

export default function useHookValue(src, countryISO) {
  return useMemo(
    () => toHookValue(src, countryISO),
    // Depends on the specific fields toHookValue reads, not `src`'s object
    // identity, so the memo stays stable across same-data re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      src?.addr1,
      src?.city,
      src?.state,
      src?.zip,
      src?.plus4,
      countryISO,
      src?.isVerified,
      src?.verificationProvider,
      src?.verifiedAt,
      src?.validationSkipped,
    ]
  );
}
